export const VariantEnum = {
  Text: 'text',
  Image: 'image',
  Block: 'block'
};